module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-2-a994d9a64294d2cfcd856fa17c21cca6.svg";